export const INPUT_STRATEGY = {
  INSERT: "insert",
  OVERWRITE: "overwrite", // default input strategy
};

export const SOURCE = {
  ALGEBRA_KIT: "algebrakit",
  MATH_TYPE: "mathtype", // default source
  CALCULATOR: "calculator",
};

export const INPUT_MODE = {
  KEYBOARD: "KEYBOARD",
  HANDWRITING: "EXTERNAL_HANDWRITING",
};

export const INTERACTION_TYPE = {
  MULTISTEP: "multistep",
};

export const EVENT = {
  TOGGLE_HANDWRITING: "toggle-external-handwriting",
  INTERACTION_CREATED: "interaction-created",
};
